import React, { useState, useEffect } from "react";
import Turnstile from "react-turnstile";
import {verifyCaptchaToken} from '../../api_handlers/auth';

const withTurnstile = (WrappedComponent) => {
  return function TurnstileProtected(props) {
    const [verified, setVerified] = useState(false);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Check if captcha was verified within the last 15 minutes
    useEffect(() => {
      const checkCaptchaStatus = () => {
        const captchaData = localStorage.getItem('captcha_verification');
        if (captchaData) {
          const { token: storedToken, timestamp } = JSON.parse(captchaData);
          const now = Date.now();
          const fifteenMinutes = 15 * 60 * 1000; // 15 minutes in milliseconds
          
          if (now - timestamp < fifteenMinutes) {
            setToken(storedToken);
            setVerified(true);
          } else {
            // Token expired, remove from localStorage
            localStorage.removeItem('captcha_verification');
          }
        }
      };

      checkCaptchaStatus();
    }, []);

    const verifyWithBackend = async (turnstileToken) => {
      setLoading(true);
      try {
        // const res = await fetch("/api/verify-turnstile/", {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({ token: turnstileToken }),
        // });

        // const data = await res.json();
        const success = await verifyCaptchaToken(turnstileToken);

        if (success) {
          setToken(turnstileToken);
          setVerified(true);
          // Store verification in localStorage with timestamp
          localStorage.setItem('captcha_verification', JSON.stringify({
            token: turnstileToken,
            timestamp: Date.now()
          }));
        } else {
          setError("Captcha verification failed. Please try again.");
        }
      } catch (err) {
        console.error(err);
        setError("Server error. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (!verified) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "100px" }}>
          <h2>Please verify you are human</h2>
          {loading && <p>Verifying...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}
          <Turnstile
            sitekey="0x4AAAAAAB3MY5WQYcAPEFs0"
            onVerify={(turnstileToken) => {
              verifyWithBackend(turnstileToken);
            }}
          />
        </div>
      );
    }

    // ✅ Once verified, pass token to wrapped component
    return <WrappedComponent {...props} turnstileToken={token} />;
  };
};

export default withTurnstile;